
import VDistpicker from '@/components/VDistpicker';
import { getBaiduMap } from '@/utils';
import { isEmpty } from '@/utils/types';

export default {
  name: 'WkLocationPointDialog',
  components: {
    VDistpicker: VDistpicker
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      map: null,
      searchInput: '', // 搜索
      searchCopyInput: '', // 避免修改
      pointAddress: null // 经纬度点
    };
  },

  computed: {},
  watch: {
    visible: function visible(val) {
      var _this = this;

      if (val) {
        this.$nextTick(function () {
          getBaiduMap().then(function () {
            var map = new BMap.Map(_this.$refs.myMap, { enableMapClick: true });
            var point = new BMap.Point(116.404, 39.915);
            if (_this.value) {
              if (!isEmpty(_this.value.lat) && !isEmpty(_this.value.lng)) {
                point = new BMap.Point(_this.value.lng, _this.value.lat);
              }

              if (!isEmpty(_this.value.address)) {
                _this.searchInput = _this.value.address;
                _this.searchCopyInput = _this.searchInput;
              }
            }

            if (!_this.value || _this.value && isEmpty(_this.value.lat) && isEmpty(_this.value.lng) && isEmpty(_this.value.address)) {
              var self = _this;
              // 定位逻辑
              var geolocation = new BMap.Geolocation();
              geolocation.getCurrentPosition(function (r) {
                if (this.getStatus() == BMAP_STATUS_SUCCESS) {
                  var myGeo = new BMap.Geocoder({ extensions_town: true });
                  // 根据坐标得到地址描述
                  myGeo.getLocation(r.point, function (result) {
                    if (result) {
                      self.searchInput = result.address;
                      self.searchCopyInput = result.address;
                      self.addMarkerLabel(result.point);
                      result.title = '';
                      self.pointAddress = result;
                    }
                  });
                }
              });
            }
            map.centerAndZoom(point, 14);
            map.enableScrollWheelZoom();
            _this.map = map;
            _this.addMarkerLabel(point);
          });
        });
      }
    }
  },
  mounted: function mounted() {},

  methods: {
    querySearchAsync: function querySearchAsync(queryString, cb) {
      if (queryString) {
        var options = {
          onSearchComplete: function onSearchComplete(results) {
            if (local.getStatus() == BMAP_STATUS_SUCCESS) {
              var address = [];
              for (var i = 0; i < results.getCurrentNumPois(); i++) {
                address.push(results.getPoi(i));
              }
              cb(address);
            } else {
              cb([]);
            }
          },
          pageCapacity: 20
        };
        var local = new BMap.LocalSearch(this.map, options);
        local.search(queryString);
      } else {
        cb([]);
      }
    },

    /**
     * 搜索结果选择
     **/
    handleSelect: function handleSelect(item) {
      this.searchInput = item.address + item.title;
      this.searchCopyInput = this.searchInput; // 只能通过这种方式修改

      this.addMarkerLabel(item.point);
      this.pointAddress = item;
    },

    /**
     * Input 失去焦点  searchInput 只能通过选择更改
     **/
    inputBlur: function inputBlur() {
      if (this.searchCopyInput !== this.searchInput) {
        this.searchInput = this.searchCopyInput;
      }
    },
    inputFocus: function inputFocus() {
      this.searchCopyInput = this.searchInput;
    },

    /**
     * 创建标注
     */
    addMarkerLabel: function addMarkerLabel(point) {
      this.map.clearOverlays();
      this.map.centerAndZoom(point, 14);
      this.map.addOverlay(new BMap.Marker(point));
    },

    /**
     * 关闭
     */
    close: function close() {
      this.$emit('update:visible', false);
    },

    /**
     * 确定选择
     */
    selectSure: function selectSure() {
      this.$emit('select', this.pointAddress);
      this.close();
    }
  }
};